import React from 'react';
import { motion } from 'framer-motion';
import { useAppStore } from '../store/appStore';

const Navigation = () => {
  const { currentPage, setCurrentPage } = useAppStore();

  const pages = [
    { id: 'landing', name: 'Home', icon: '🏠' },
    { id: 'project', name: 'Projects', icon: '🚀' },
    { id: 'ai', name: 'AI', icon: '🤖' },
    { id: 'network', name: 'Team', icon: '👥' }
  ];

  return (
    <div className="navigation">
      {pages.map((page, index) => (
        <motion.button
          key={page.id}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          className={`nav-dot ${currentPage === page.id ? 'active' : ''}`}
          onClick={() => setCurrentPage(page.id)}
          title={page.name}
          whileHover={{ scale: 1.2 }}
          whileTap={{ scale: 0.9 }}
        >
          <span className="absolute -left-16 top-1/2 transform -translate-y-1/2 text-xs whitespace-nowrap opacity-0 hover:opacity-100 transition-opacity">
            {page.icon} {page.name}
          </span>
        </motion.button>
      ))}
      
      {/* Progress Line */}
      <motion.div
        className="absolute left-1/2 top-0 w-0.5 h-full bg-white/20 transform -translate-x-1/2"
        initial={{ scaleY: 0 }}
        animate={{ scaleY: 1 }}
        transition={{ duration: 1, delay: 0.5 }}
      />
      
      {/* Current Page Indicator */}
      <motion.div
        className="absolute left-1/2 w-0.5 bg-gradient-to-b from-cyan-400 to-purple-400 transform -translate-x-1/2"
        initial={{ height: 0, top: 0 }}
        animate={{
          height: `${(pages.findIndex(p => p.id === currentPage) + 1) * (100 / pages.length)}%`,
          top: 0
        }}
        transition={{ duration: 0.5 }}
      />
    </div>
  );
};

export default Navigation;
